<template>
  <div>
    <el-dialog
      title="培训人员信息"
      class="dialog_container"
      :visible.sync="trainId.state"
      width="60%"
      :before-close="dialogVisibleClone"
      append-to-body
    >
      <!-- 表单 -->
      <el-form
        :show-message="false"
        :validate-on-rule-change="false"
        label-position="left"
        label-width="120px"
        ref="formData"
        :model="formData"
      >
        <!-- 培训主题 -->
        <el-form-item label="培训主题：" prop="theme">
          <el-input v-model.trim="formData.theme" disabled></el-input>
        </el-form-item>
        <!-- 主讲人 -->
        <el-form-item label="主讲人：" prop="speaker">
          <el-input v-model.trim="formData.speaker" disabled></el-input>
        </el-form-item>
        <!-- 培训时间 -->
        <el-form-item label="培训时间：" prop="startTime">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            disabled
            placeholder="开始时间"
            class="searchTjContentDivInput"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <span class="searchTjContentDivSpan" style="padding: 0 20px">至</span>
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            disabled
            placeholder="结束时间"
            class="searchTjContentDivInput"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 培训地点 -->

        <!-- 培训技能 -->
        <el-form-item label="培训技能：" prop="skillId">
          <el-select
            style="width: 100%"
            disabled
            v-model="formData.skillId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in skillList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 培训内容 -->
        <el-form-item label="培训内容：" prop="content">
          <el-input
            type="textarea"
            v-model="formData.content"
            disabled
          ></el-input>
        </el-form-item>
        <!-- 参与人员 -->
        <el-form-item label="参与人员：" prop="people">
          <!-- 点击弹出新增参与人员的小弹窗 -->
          <!-- <el-button
              type="success"
              style="padding: 8px 15px"
              icon="iconfont icon-xinzeng"
              @click="addperson('新增', 'add')"
              >新增</el-button
            > -->

          <!-- 参与人员table弹窗 -->

          <el-table :data="addPersonData" border style="width: 100%">
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="personName"
              label="姓名"
              width="100"
            >
            </el-table-column>
            <el-table-column align="center" prop="personPhone" label="联系方式">
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 发布平台 -->
        <el-form-item label="发布平台：" prop="platform">
          <el-checkbox-group v-model="formData.platform" disabled>
            <el-checkbox label="0">APP</el-checkbox>
            <!-- <el-checkbox label="1">公众号</el-checkbox>
                <el-checkbox label="2">Web</el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="培训地点：">
          <div class="addressContent">
            <div class="addressBox">
              <div class="addressItem">
                <el-form-item prop="shengjiId">
                  <el-select
                    v-model="formData.shengjiId"
                    placeholder="请选择省"
                    disabled
                    ref="selectShengChange"
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="shijiId">
                  <el-select
                    v-model="formData.shijiId"
                    disabled
                    placeholder="请选择市"
                    ref="selectShiChange"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="qujiId">
                  <el-select
                    v-model="formData.qujiId"
                    disabled
                    placeholder="请选择区"
                    ref="selectQuChange"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="streetId">
                  <el-select
                    v-model="formData.streetId"
                    disabled
                    placeholder="请选择街道"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="shequjiId">
                  <el-select
                    v-model="formData.shequjiId"
                    disabled
                    placeholder="请选择社区"
                    ref="selectShequChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item prop="place" style="margin: 5px 0">
              <input
                v-model.trim="formData.place"
                id="tipinput"
                disabled
                class="el-input__inner"
                @focus="getMap('tipinput')"
                placeholder="请输入关键字"
                autocomplete="off"
              />
            </el-form-item>
            <div class="map_container">
              <div id="container1" style="width: 100%; height: 200px"></div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import { quillEditor } from "vue-quill-editor"
export default {
  props: ["trainId"],

  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      formData: {},
      serviceTypeList: [],
      addPersonData: [],
      province: "",
      city: "",
      district: "",
      provinceList: [], //
      cityList: [],
      areaList: [],
      streetList: [],
      polygons: [],
      communityList: [],
      // 培训技能列表
      skillList: [],
      street: "",
      infoData: [],
      pageConfig: {
        pageNum: 1,
        pageSize: 10,
      },
      totalCount1: 0,
      healthCondition: [],
      controlAddContent: "1", // 控制新增弹框内部内容的切换
    }
  },
  created() {
    this.baseUrl =
      baseURL + "/sqyl/controller/uploadController/info/uploadPhoto"
    this.getSkill()
  },
  async mounted() {
    this.getData()
  },
  methods: {
    dialogVisibleClone() {
      this.$emit("setTrain")
      this.dialogVisible = false
    },

    getData() {
      request({
        url: "/sqyl/admin/train/info/get",
        method: "POST",
        data: {
          id: this.trainId.id,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          this.loadMap("container1")
          this.formData = res.content
          if (this.formData.content != null) {
            this.formData.content = this.formData.content.replace(
              /<\/?.+?>/g,
              ""
            )
          }
          this.formData.platform = this.formData.platform.split(",")
          this.addPersonData = res.content.trainPersonList

          let province = await this.getDistricts()
          this.provinceList = province.districtList
          console.log(this.provinceList, "-----")
          this.formData.shengjiId = String(this.formData.shengjiId)
          this.formData.shijiId = String(this.formData.shijiId)
          this.formData.qujiId = String(this.formData.qujiId)
          this.formData.streetId = String(this.formData.streetId)
          if (!this.formData.shengjiId) return
          let city = await this.getDistricts(this.formData.shengjiId)
          this.cityList = city.districtList
          if (!this.formData.shijiId) return
          let area = await this.getDistricts(this.formData.shijiId)
          this.areaList = area.districtList
          if (!this.formData.qujiId) return
          let street = await this.getStreetList(this.formData.qujiId)
          this.streetList = street
          if (!this.formData.streetId) return
          let communityList = await this.getCommityList(this.formData.streetId)
          this.communityList = communityList
          this.formData.shequjiId = Number(this.formData.shequjiId)
          this.formData.latitude = res.content.latitude
          this.formData.longitude = res.content.longitude
          console.log(this.formData.longitude)
          setTimeout(async () => {
            await this.$nextTick(() => {
              this.loadMap("container1")
              this.potintMap()
            })
          }, 30)
          this.$forceUpdate()
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    // 获取培训技能
    getSkill() {
      let params = {
        pageNo: 1,
        pageSize: -1,
        type: "6",
        status: "0",
      }
      request({
        url: "/jjyl/admin/ststemdata/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content == null || res.content == "null") {
            this.skillList = []
            return
          }
          this.skillList = res.content.list
        } else {
          this.$message({
            message: "获取培训技能列表失败",
            type: "error",
          })
        }
      })
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map("container1", {
          resizeEnable: true,
          zoom: 8,
        })
        resolve()
      })
    },

    innerSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getList()
    },
    innerCurrentChange(val) {
      console.log(val, 9)
      this.pageConfig.pageNum = val
      this.getList()
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.longitude),
          Number(self.formData.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {})
    },
    // 地图
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.quId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        self.potintMap()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
  },
}
</script>

<style lang="less" scoped>
.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-bottom {
  width: 100%;
  text-align: center;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.operation-color:hover {
  color: #00aaff;
}

.bottom-page {
  margin: 20px 0;
}

.btn_group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.dialog-footer {
  width: 100%;
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.collegebox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.infoBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.serviceInfoBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.rightBox {
  margin-left: 30px;
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.row-bg {
  margin-bottom: 20px;
}

.rightBox {
  margin-left: 30px;
  text-align: center;
}

.uploadBtn {
  width: 178px;
  height: 50px;
  margin-left: 5px;
  background-color: #66b1ff;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  line-height: 50px;
  margin-top: 20px;
}

.el-dialog__body {
  padding-top: 0;
}
.addressContent {
  flex: 1;

  .addressBox {
    display: flex;

    .addressItem {
      flex: 1;

      /deep/ .el-form-item__content {
        margin-left: 0px !important;
      }

      /deep/ .el-select {
        width: 100% !important;
      }
    }
  }

  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
}
</style>
